import yourInformationReducer from './yourInformationReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import serviceAvailableReducer from './apiReducers/serviceAvailableReducer'
import masterNumberValidatorReducer from './apiReducers/masterNumberValidatorReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  yourInformation: yourInformationReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  serviceAvailable: serviceAvailableReducer,
  masterNumberValidator: masterNumberValidatorReducer,
})

export default rootReducer
